import React from 'react';
import { FaArrowLeft, FaUserPlus, FaArrowRight } from 'react-icons/fa';
import TryItNowWidget from './landing/TryItNowWidget';
import SEO from './SEO';
import { SEO_BASE_URL } from '../config';

const TryoutPage = ({ onBack, onGetStarted, onLogin, initialDestination }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-accent-50">
      {/* This is where social posts should land — it demonstrates the product
          rather than describing it. Without its own tags a shared /tryout link
          previewed as the generic site card, which is indistinguishable from a
          link to the homepage and converts like one. */}
      <SEO
        title="Try the AI trip planner free - no signup"
        description="Type a destination and watch a real day-by-day plan appear: actual attractions, photos, maps and where to stay. Free, no account needed."
        canonical={`${SEO_BASE_URL}/tryout`}
      />
      <header className="bg-white/80 backdrop-blur-sm border-b border-neutral-200 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-neutral-600 hover:text-neutral-900 transition-colors"
          >
            <FaArrowLeft /> <span className="font-medium">Back</span>
          </button>
          <div className="flex items-center gap-2">
            <button
              onClick={onLogin}
              className="px-4 py-2 text-sm font-medium text-neutral-700 hover:text-neutral-900 transition-colors"
            >
              Log in
            </button>
            <button
              onClick={onGetStarted}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-primary-500 to-accent-500 text-white px-4 py-2 rounded-lg font-semibold text-sm shadow-md hover:shadow-glow-primary transition-all"
            >
              <FaUserPlus size={12} /> Sign up free
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-5xl font-bold font-display text-neutral-800 mb-3">
            Try a Sample Itinerary
          </h1>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
            Type any destination and we'll generate a Day-1 preview with real attractions, photos, and map links — no signup needed.
          </p>
        </div>

        <TryItNowWidget initialDestination={initialDestination} />

        <div className="mt-12 bg-white rounded-2xl shadow-card border border-neutral-100 p-8 text-center">
          <h2 className="text-2xl font-bold font-display text-neutral-800 mb-2">
            Like what you see?
          </h2>
          <p className="text-neutral-600 mb-6 max-w-xl mx-auto">
            Sign up free to get the full multi-day plan with maps, flights, expenses, hotel suggestions, and live re-optimization.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={onGetStarted}
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-primary-500 via-accent-500 to-adventure-500 text-white px-8 py-3 rounded-xl font-semibold shadow-elevated hover:shadow-glow-primary hover:scale-105 transition-all duration-300"
            >
              Create your free account
              <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={onLogin}
              className="text-neutral-600 hover:text-neutral-900 font-medium text-sm transition-colors"
            >
              Already have an account? Log in
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TryoutPage;
